// dateHelper.js

export function formatDateForInput(value) {
    if (!value) {
        return null;
    }

    // return value.split("T")[0];
    return value.substring(0, 10);
}
